import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";

const ExprimeCharteDepot = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow relative overflow-hidden">
        {/* Background with gradient and gavroche */}
        <div className="absolute inset-0 z-0">
          <div className="h-full w-full bg-gradient-to-br from-[#FFFF4D] via-[#FFE94B] to-[#A3D960]"></div>
          <div className="absolute top-0 right-0 h-full w-1/3 md:w-2/5 opacity-30 md:opacity-40 flex items-end">
            <img 
              src="/lovable-uploads/180f51c0-05cf-4dfd-b4b7-91b153baf486.png" 
              alt="Décoration" 
              className="h-auto w-full object-contain object-bottom drop-shadow-xl" 
            />
          </div>
        </div>
        
        <div className="container relative z-10 mx-auto px-4 py-16 pt-32">
          <Card className="max-w-3xl mx-auto bg-white/90 backdrop-blur-sm">
            <CardContent className="pt-8 pb-12 px-6">
              <h1 className="text-4xl font-bold text-center mb-8 text-[#001233]">
                Dépôt du projet
              </h1>
              
              <p className="text-center text-lg text-[#001233]">
                La page "Dépot" qui servira à déposer votre oeuvre sera disponible à partir d'avril 2026
              </p>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ExprimeCharteDepot;
